/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import React from 'react';

import { useAccount, useLogout } from '~/apis';
import { useTranslation } from '~/app';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '~/components/Dialog/Dialog';
import { Button } from '~/components/Form/Button';

interface Props {
  modalOpen: boolean;
  onModalClose: () => void;
  onLogout: () => void;
}

const LogoutDialog = ({ modalOpen, onModalClose, onLogout }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { data: account } = useAccount();

  const logout = useLogout(onLogout);

  return (
    <Dialog open={modalOpen} onOpenChange={(open) => !open && onModalClose()}>
      <DialogContent size="md" onEnterKey={logout}>
        <DialogTitle>{t('start_accountLogoutDialogTitle')}</DialogTitle>
        <DialogDescription className="selectable-text">
          {t('start_accountLogoutDialogContent', {
            placeholders: {
              name: account?.username || '',
            },
          })}
        </DialogDescription>

        <div className="mt-6 flex justify-end space-x-3">
          <Button variant="secondary" onClick={onModalClose}>
            {t('start_accountDialogCancel')}
          </Button>
          <Button variant="primary" onClick={logout}>
            {t('start_accountLogoutDialogEnter')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutDialog;
